import PBService from "@irati/utils/services"
import client, {QueryOptions} from "@irati/utils/services/apollo"
import loginGhostTokenForBusinessQuery, {loginGhostTokenForBusinessKey} from "./queries/loginGhostTokenForBusiness"
import loginGhostQuery, {loginGhostKey} from "./queries/loginGhost"
import tokens from "./tokens"
import AuthStream from "../streams/auth"

class GhostLogin extends PBService {
  getTokenForBusiness(businessId: string, userId: string, options: QueryOptions = {}) {
    const variables = {businessId, userId}
    return client
      .query({...options, fetchPolicy: "no-cache", query: loginGhostTokenForBusinessQuery, variables})
      .then(({data}) => data[loginGhostTokenForBusinessKey])
  }

  login(accessToken: string, options: QueryOptions = {}): Promise<void> {
    tokens.set({accessToken})
    return client.query({...options, query: loginGhostQuery}).then(({data}) => {
      const {user, business} = data[loginGhostKey]

      return AuthStream.start({user, business})
    })
  }
}

export default new GhostLogin({errorHandlers: []})
